export default {
  inviteFriends: "دعوت از دوستان",
  recieveReward: "کد یا لینک دعوت را به دوستانتان بدهید و با هم پاداش بگیرید.",
  guidAndRules: "راهنما و قوانین دعوت از دوستان",
  inviteLink: "لینک دعوت",
  todayRewardValue: "ارزش پاداش‌های امروز",
  sumOfInvited: "مجموع دعوت شده‌ها",
  invitedList: "لیست دعوت شده‌ها",
  filters: "فیلترها",
  for: "بابت",
  invitationCodeCopied: "کد دعوت کپی شد.",
  invitationLinkCopied: "لینک دعوت کپی شد.",
  inviteCode: "کد دعوت",
  noInviteMsg: "هنوز کسی را دعوت نکرده‌اید"
};
